<template>
    <div class="row">
        <div class="col-12 d-flex align-items-center justify-content-center">
            <div class="d-flex flex-column">
                <div class="text-center">
                <h1>{{ $t('views.notFound.title') }}</h1>
                <p> {{ $t('views.notFound.description') }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "NotFound",
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from
            vm.$http.post('/collect', {
                url: from.fullPath,
                ts: new Date()
            }).then(res => {}).catch(err => {})
        })
    }
}
</script>

<style lang="scss" scoped>
    .row {
        height: 85vh;
    }
</style>